import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {BackendModule} from '../modules/backend.module';
import {SessionService} from './session';
import {AnalyticsService} from './analytics';
import {SignInPage} from '../pages/auth/sign-in/sign-in';

@Injectable()
export class AuthService {

  signInPage = SignInPage;
  timeouts = {}; // for checkAvailability() debounce

  constructor(public backendModule: BackendModule,
              public sessionService: SessionService,
              public analyticsService: AnalyticsService,
  ) {

  }

  // we copy the "trackEvent()" method here for convenience for auth clients
  trackEvent(category, action, label?, value?) {
    console.log('auth track event:', category, action, label, value);
    this.analyticsService.trackEvent(category, action, label, value);
  }

  logIn = (user) => {
    return new Promise((resolve, reject) => {
      this.backendModule.signIn(user)
        .subscribe(
          (response: any) => {
            console.log('1', response ? response : 'no')
            this.getUserInfo(response.data.id)
              .then(() => {
                this.trackEvent('auth', 'login', response.data.id);
                resolve()
              })
              .catch((error) =>
                reject(error)
              )
          },
          (error) => {
            console.log(error);
            this.trackEvent('auth', 'bad-password');
            let errorMsg = error.error.errors[0];
            reject(errorMsg)
          }
        )
    })
  }

  register = (user) => {
    return new Promise((resolve, reject) => {
      this.backendModule.post('auth',
        {
          city_id: user.city_id,
          config_name: 'default',
          confirm_success_url: `${this.backendModule.backendURL}/welcome`,
          email: user.email,
          lastname: user.lastname,
          name: user.name,
          password: user.password,
          password_confirmation: user.password,
          plan_type: 'regular',
          profile: {
            phone: user.phone,
            birthday: user.birthday,
            gender: user.gender,
          }
        },
        {observe: 'response'}
      ).subscribe((response: any) => {
        let userId = response.body.data.id;
        this.getUserInfo(userId).then(() => {
          this.trackEvent('auth', 'register', userId);
          resolve()
        }).catch(err => reject(err))
      }, err => reject(err));
    })
  }

  getUserInfo(userId) {
    return new Promise((resolve, reject) =>
      this.backendModule.getAPI(`users/${userId}?reservations=cycle`)
        .subscribe((data: any) => {
            console.log('2', data ? data : 'no')
            this.sessionService.user = {
              beauty: data.beauty,
              city_id: data.city_id,
              favorite_gyms: data.favorite_gyms,
              trending_gyms: data.trending_gyms,
              cycle_dates: data.cycle_dates,
              cycle_dates_beauty: data.cycle_dates_beauty,
              email: data.email,
              id: data.id,
              incomes: data.incomes,
              lastname: data.lastname,
              name: data.name,
              picture_url: data.picture_url,
              plan_type: data.plan_type,
              pro: data.pro,
              policy_version: data.policy_version,
              profile:
                data.profile ||
                this.sessionService.defaultProfile,
              reservations: data.lessons,
              subscription: data.subscription,
              beauty_subscription: data.beauty_subscription,
              tutorial_seen: data.tutorial_seen,
              user_type: data.user_type,
              paused: data.paused,
              paused_until: data.paused_until,
              classes_version: data.classes_version,
              profile_version: data.profile_version,
              home_version: data.home_version,
            };

            this.sessionService.save()

            console.warn('session save', this.sessionService.user);
            resolve()
          },
          (err) => {
            reject(err)
          }
        ))
  }

  logOut() {
    this.trackEvent('auth', 'logout', this.sessionService.user.id);
    this.backendModule.signOut();
    this.sessionService.destroy();
  }

  recoverPassword(email) {
    return new Promise((resolve, reject) => {
      this.backendModule.post('auth/password',
        {
          email: email,
          redirect_url: `${this.backendModule.backendURL}/reset_password`
        },
        {observe: 'response'}
      ).subscribe((response: any) => {
          this.trackEvent('auth', 'reset-password');
          resolve()
        },
        err => {
          reject(err)
        }
      );
    })
  }

  // NOTE: 'field' is either "phone" or "email"
  checkAvailability(field: string, value: string) {
    if (this.timeouts[field]) clearTimeout(this.timeouts[field]);
    return new Promise((resolve, reject) => {
      this.timeouts[field] = setTimeout(() => {
        let params = new HttpParams();
        params = params.append(field, value);
        this.backendModule.getAPI('registered', {params: params}
        ).subscribe((response: any) => {
            if (!response.registered) {
              resolve()
            } else {
              reject()
            }
          },
          err => {
            reject(err)
          }
        );
      }, 500); // Wait until the user stops typing for 0.5 seconds
               // before checking if the value is available or not
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.ts